import { getCurrentUserEmail } from '../auth';
// --- OLD: using HRIS employee store (commented out, replaced by UserMaster) ---
// import { getEmployeeData } from '../employeeStore';
// --- NEW: using UserMaster data ---
import { getUserDivision } from '../roleAccessService';

export const buildGeneralInformationPayload = (formData) => {
  const currentUser = getCurrentUserEmail();
  const currentDate = new Date().toISOString();

  // --- OLD: get division from HRIS employee data ---
  // const employeeData = getEmployeeData();
  // const divisionCode = employeeData?.Division_Code || employeeData?.["0"]?.Division_Code || "";

  // --- NEW: get division from UserMaster ---
  const divisionCode = getUserDivision();

  return {
    EightDInfoId: formData.eightDInfoId || 0,
    ReportNo: formData.reportNo || "",
    OriginatorEmailId: currentUser,
    CoordinatorEmailId: "",
    ComplainReportingDate: currentDate,
    ProblemStatement: formData.problemStatement || "",
    StartDate: formData.startDate ? new Date(formData.startDate).toISOString() : null,
    EndDate: null,
    SourceOfComplain: formData.sourceOfComplain || "",
    PartNo: formData.partNo || "",
    PartDescription: formData.partDescription || "",
    SupplierName: formData.supplierName || "",
    IsRecurringIssue: formData.isRecurringIssue || false,
    IsCustomerSafetyEffect: formData.isCustomerSafetyEffect || false,
    SeverityPoints: formData.severityPoints || "",
    Status: "Drafted",
    Division: divisionCode,
    MomId: parseInt(formData.momId) || 0,
    MomMatterId: parseInt(formData.momMatterId) || 0,
    CreatedBy: currentUser,
    CreatedOn: currentDate,
    ModifiedBy: currentUser,
    ModifiedOn: currentDate,
    IsDeleted: false
  };
};
